module.exports = __webpack_public_path__ + "static/how-to-unlock-hidden-skills-88788cdaa0825fc2d505851a33873807.png";